export default "__VITE_ASSET__BY1XBdiq__"